import { FC, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import IconUp from '../../../icons/icon__sort-ascending.svg'
import IconDown from '../../../icons/icon__sort-descending.svg'
import { Menu, MenuItem } from '../../Menu/desktop'
import { Dropdown } from '../../Dropdown/desktop'
import { ISortButton } from '../types'

const Block = styled.div`
  padding: 10px 0 10px 15px;
`

const MenuItemWrap = styled.div``

const SortButton: FC<ISortButton> = (props) => {
  const { list, activeIndex, onClick } = props
  const [activeItem, setActiveItem] = useState(list[activeIndex])

  useEffect(() => {
    setActiveItem(list[activeIndex])
  }, [list, activeIndex])

  const MenuBlock = useMemo(() => {
    return (
      <div
        style={{
          marginLeft: '25px',
        }}
      >
        <Menu spacing={['xxsmall', 'xsmall']} shadow>
          {list.map((item, key) => (
            <MenuItemWrap
              onClick={() => {
                onClick(key, item.key, item.direction)
              }}
              key={key}
            >
              <MenuItem active={key === activeIndex}>
                <a>{item.name}</a>
              </MenuItem>
            </MenuItemWrap>
          ))}
        </Menu>
      </div>
    )
  }, [list, activeIndex, activeItem, onClick])

  const IconBlock = (
    <div
      style={{
        marginLeft: '-15px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {activeItem?.direction === 'asc' ? (
        <IconUp width='20px' color='blue' />
      ) : (
        <IconDown width='20px' color='blue' />
      )}
    </div>
  )

  return (
    <Block>
      <Dropdown
        menu={MenuBlock}
        title={activeItem?.name}
        color='blue'
        StartIcon={IconBlock}
        width='315px'
        arrowMenu={false}
      />
    </Block>
  )
}

export default SortButton
